module.exports = __webpack_public_path__ + "static/media/Cardo-Regular.22d924e0.woff";